<template>
  <div class="space-y-4 px-4 h-full">
    <div v-if="userIsSignedIn" class="h-full">
      <div v-if="$store.state.myOrders.length > 0">
        <OrderItem
          class="my-2"
          v-for="item in $store.state.myOrders"
          :order="item"
          :key="item"
        />
      </div>
      <NoOrder v-else class="flex flex-col justify-center h-full" />
    </div>
    <div v-else class="flex flex-col justify-center space-y-3 h-full">
      <p class="font-semibold text-lg">You are not signed in</p>
      <div>
        <button
          @click="login"
          class="shadow-lg border-white border font-bold text-lg p-1 px-4 rounded-full bg-bnb-mustard bg-opacity-70 text-white"
        >
          Log In/Sign Up
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import NoOrder from "@/views/orders/NoOrder.vue";
import OrderItem from "@/views/orders/OrderItem.vue";
export default {
  components: { NoOrder, OrderItem },
  computed: {
    userIsSignedIn() {
      return firebase.auth().currentUser;
    },
  },
  methods: {
    login() {
      this.$router.replace({ name: "Authenticate" });
    },
  },
};
</script>
